export default __webpack_public_path__ + "static/media/GR3 3A-1EC.74e7951f.jpg";